import { FC, useEffect, useRef } from "react";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../../assets/css/login/index.css";

import { authLoginByToken } from "../../actions/login";
import { checkValidJwt } from "../../utils";
import Spinner from "../../Components/Spinner";

import { useSelector, useDispatch } from "react-redux";
import { Dispatch } from "redux";

const styles: React.CSSProperties = {
  backgroundImage: `url(${process.env.PUBLIC_URL}/commons/bg_login.png)`,
};

const decodeParam = (param: string) => {
  return decodeURIComponent(param).replace(/ /g, "+");
};

const AuthAtomatico: FC = ({ history }: any) => {
  const [selectAmb, setSelectAmb] = useState<boolean>(false);
  const navigate = useNavigate();

  const { ambientes, jwt } = useSelector((state: any) => state.user);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token");
  const key = queryParams.get("key");

  const dispatch: Dispatch = useDispatch();
  const hasLoggedInRef = useRef(false); // <- evita múltiples ejecuciones

  useEffect(() => {
    if (ambientes && ambientes.length > 0) {
      setSelectAmb(true);
    }
  }, [ambientes]);

  useEffect(() => {
    const isValid = checkValidJwt(jwt);
    console.log("isValid", isValid);

    if (jwt && isValid) {
      navigate("/inicio");

    }
  }, [jwt, navigate]);

  useEffect(() => {
    if (token && key && !hasLoggedInRef.current) {
      handleLogin({ token, key });
    }
  }, [token, key]);

  const handleLogin = async ({
    token,
    key,
  }: {
    token: string;
    key: string;
  }) => {
    if (hasLoggedInRef.current) return;
    hasLoggedInRef.current = true;

    await dispatch(
      authLoginByToken(decodeParam(token), decodeParam(key)) as any
    );
  };

  return (
    <div className={selectAmb ? "main end" : "main"} style={styles}>
      <Spinner />
    </div>
  );
};

export default AuthAtomatico;
